import React, { useContext } from 'react'
import { Box, Flex } from 'theme-ui'
import IconWrapper from '../IconWrapper/IconWrapper'
import { ICONS } from '../../../constants/iconConstants'
import { COLORS } from '../../../constants/themeConstants'
import { UserContext } from '../../../providers/UserProvider'
import {
  LOYALTY_TYPE_NEXT,
  LOYALTY_TYPE_NEXT_PREMIUM,
  LOYALTY_TYPE_PPFS,
} from '../../../constants/customerLoyalty'
import { ActiveUserStateContext } from '../../../providers/ActiveUserStateProvider'
import i18next from 'i18next'

const PRICE_SOURCE_FLEET_PRICE = 'FLEET PRICE'
const PRICE_SOURCE_SPECIAL_PRICE = 'SPECIAL PRICE'
const PRICE_SOURCE_DEAL = 'DEAL'
const PRICE_SOURCE_DEALER_DEAL = 'DEALER DEAL'

interface LoyaltyDiscountLabelProps {
  size?: 'small' | undefined
  dealSource?: {
    lowestPriceSource: string | null
    daysLeft: number | null
  }
  noIcon?: boolean
}
const LoyaltyDiscountLabel = ({
  dealSource,
  size,
  noIcon,
}: LoyaltyDiscountLabelProps) => {
  if (!dealSource?.lowestPriceSource) return null

  const { activeUserState } = useContext(ActiveUserStateContext)
  const { userProfile } = useContext(UserContext)

  const loyaltyProgram = userProfile?.companies?.find(
    (company) => company.companyId === activeUserState?.selectedCustomerCompanyId
  )?.customerLoyaltyTypeName

  if (
    (dealSource.lowestPriceSource === PRICE_SOURCE_FLEET_PRICE ||
      dealSource.lowestPriceSource === PRICE_SOURCE_SPECIAL_PRICE) &&
    loyaltyProgram !== LOYALTY_TYPE_NEXT_PREMIUM &&
    loyaltyProgram !== LOYALTY_TYPE_PPFS
  ) {
    return null
  }

  if (
    dealSource.lowestPriceSource === PRICE_SOURCE_FLEET_PRICE ||
    dealSource.lowestPriceSource === PRICE_SOURCE_SPECIAL_PRICE
  ) {
    noIcon = true
  }

  let textColor = COLORS.PROMOTION
  let primaryColor = COLORS.PROMOTION
  let secondaryColor = COLORS.PROMOTION_DARK

  switch (loyaltyProgram) {
    case LOYALTY_TYPE_NEXT_PREMIUM:
      textColor = COLORS.ALERT
      primaryColor = COLORS.ALERT
      secondaryColor = COLORS.ALERT_DARK
      break
    case LOYALTY_TYPE_NEXT:
      textColor = COLORS.DAF_DARK_BLUE
      primaryColor = COLORS.DAF_BLUE
      secondaryColor = '#000135'
      break
    case LOYALTY_TYPE_PPFS:
      textColor = COLORS.DAF_DARK_BLUE
      primaryColor = '#5C98C3'
      secondaryColor = '#33237A'
      break
    case 'DD':
      textColor = COLORS.MEDIUM_DARK
      primaryColor = '#757575'
      secondaryColor = '#2F4259'
      break
    default:
      break
  }

  let label = ''

  switch (dealSource?.lowestPriceSource) {
    default:
    case PRICE_SOURCE_DEAL:
    case PRICE_SOURCE_DEALER_DEAL:
      if (dealSource?.daysLeft && dealSource.daysLeft < 2) {
        label = i18next.t('discountPriceLabels.finalDay')
      } else if (dealSource?.daysLeft && dealSource.daysLeft < 6) {
        label = i18next.t('discountPriceLabels.xDaysLeft', {
          daysLeft: dealSource?.daysLeft,
        })
      } else {
        label = i18next.t('discountPriceLabels.deal')
      }
      break
    case PRICE_SOURCE_SPECIAL_PRICE:
      label = i18next.t('discountPriceLabels.specialPrice')
      break
    case PRICE_SOURCE_FLEET_PRICE:
      label = i18next.t('discountPriceLabels.fleetPrice')
      break
  }

  return (
    <Flex
      sx={{
        alignItems: 'stretch',
        inlineSize: 'max-content',
        borderRadius: 4,
        overflow: 'hidden',
        '--text-color': textColor,
        '--primary-color': primaryColor,
        '--secondary-color': secondaryColor,
      }}
    >
      {!noIcon && (
        <Flex
          sx={{
            backgroundImage:
              'linear-gradient(90deg, var(--secondary-color), var(--primary-color))',
            padding: 1,
            paddingBlock: size === 'small' ? '2px' : 1,
          }}
        >
          <IconWrapper
            icon={ICONS.DEALS}
            size={2}
            color={COLORS.WHITE}
            style={{
              display: 'block',
            }}
          ></IconWrapper>
        </Flex>
      )}

      <Box
        sx={{
          backgroundImage:
            'linear-gradient(90deg, var(--primary-color), var(--secondary-color))',
          padding: '1px',
          paddingInlineStart: !noIcon ? 0 : null,
        }}
      >
        <Box
          sx={{
            backgroundColor: COLORS.WHITE,
            blockSize: '100%',
            borderEndEndRadius: 3,
            borderStartEndRadius: 3,
            borderRadius: noIcon ? 3 : null,
            color: 'var(--text-color)',
            fontSize: size === 'small' ? 10 : 12,
            fontWeight: 500,
            textTransform: 'uppercase',
            letterSpacing: '0.2px',
            display: 'flex',
            alignItems: 'center',
            paddingBlock: size === 'small' ? '2px' : 1,
            paddingInline: 2,
          }}
        >
          <Box>{label}</Box>
        </Box>
      </Box>
    </Flex>
  )
}

export default LoyaltyDiscountLabel
